module.exports = __webpack_public_path__ + "img/HeaderRow2PlaceholderMobile.83a1643a.svg";